import React from "react";

import GlobalChartDialog from "components/basic/chart-in-dialog-button/GlobalChartDialog";
import { ConfirmPopup } from "primereact/confirmpopup";
import EasasGlobalAlerts from "./EasasGlobalAlerts";
import EasasGlobalChartDialog from "./EasasGlobalChartDialog";
import EasasGlobalConfirmDialog from "./EasasGlobalConfirmDialog";
import EasasGlobalTooltip from "./EasasGlobalTooltip";

export default function EasasGlobalFragment() {
  return (
    <>
      <GlobalChartDialog />
      <ConfirmPopup />
      <EasasGlobalTooltip />
      <EasasGlobalAlerts />
      <EasasGlobalChartDialog />
      <EasasGlobalConfirmDialog />
    </>
  );
}
